/*** IMPORTS FROM imports-loader ***/
var define = false;

var native = require('./native');
var util = require('./util');
var conf = require('./conf');
var event = require('./event');

/**
 * @todo 参数检查
 * @todo 缓存
 * @todo 调试模式
 * @todo err返回错误描述不是很合理，万一要做判断就坑爹了
 * @todo 修改track event示例和单元测试
 * @todo 需要修改文档结构
 */

/**
 * @callback dataCallback
 * @param {(string|null)} err - 错误信息
 * @param {(string|boolean)} [val] - 返回值
 */

/**
 * @callback checkCallback
 * @param {boolean} exist - 方法是否存在
 */

/** @callback handler */

/**
 * @callback loginHandler
 * @param {string} userId - 用户id
 * @param {string} jumpKey - jump key
 */

/**
 * @callback changeSkinHandler
 * @param {string} skinId - 皮肤id
 * @param {string} isVip - 是否是会员
 * @param {string} skinInfo - 皮肤信息
 */

var xl9 = {
  api: {
    /**
     * 调用本地接口
     * @function call
     * @param {string} name - 方法名
     * @param {...*} params - 方法需要的参数，可能是0个，1个或多个
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.call('ShowVipMiniPage', function (err) {
     *   if (!err) {
     *     console.log('show vip mini page');
     *   }
     * });
     */
    call: function () {
      var args = Array.prototype.slice.call(arguments);
      if (typeof args[args.length - 1] !== 'function') {
        args.push(null);
      }
      native.callNativeFunction.apply(null, args);
    },

    /**
     * 检查本地接口是否存在
     * @function check
     * @param {string} name - 方法名
     * @param {checkCallback} callback - 回调函数
     * @example
     * xl9.api.check('GetUserID', function (exist) {
     *   console.log('GetUserID is exist: ' + exist)
     * });
     */
    check: function (name, callback) {
      native.checkNativeFunction(name, function (exist) {
        if (exist === 0) {
          callback(true);
        } else {
          callback(false);
        }
      });
    },

    /**
     * 监听本地事件
     * @function attach
     * @param {string} event - 事件类型
     * @param {handler} callback - 事件处理器
     * @returns {number} 事件标识
     * @example
     * xl9.api.attach('OnUserLogin', function (userId, jumpKey) {
     *   console.log(userId + ', ' + jumpKey);
     * });
     */
    attach: function (type, callback) {
      if (type === 'OnUserLogin') {
        return event.loginAttach(callback);
      } else {
        return native.attachNativeEvent.apply(null, arguments);
      }
    },

    /**
     * 解绑本地事件
     * @function detach
     * @param {string} type - 事件类型
     * @param {number} eventId - 事件标识
     * @example
     * xl9.api.detach('OnUserLogin', 0);
     */
    detach: function (type, eventId) {
      if (type === 'OnUserLogin') {
        event.loginDetach(eventId);
      } else {
        native.detachNativeEvent.apply(null, arguments);
      }
    },

    /**
     * 获取用户ID
     * @function getUserId
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.getUserId(function (err, userId) {
     *   if (!err) {
     *     console.log(userId);
     *   }
     * });
     */
    getUserId: function (callback) {
      native.callNativeFunction('GetUserID', callback);
    },

    /**
     * 获取Jump Key
     * @function getJumpKey
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.getJumpKey(function (err, jumpKey) {
     *   if (!err) {
     *     console.log(jumpKey);
     *   }
     * });
     */
    getJumpKey: function (callback) {
      native.callNativeFunction('GetJumpKey', callback);
    },

    /**
     * 获取peerId
     * @function getPeerId
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.getPeerId(function (err, peerId) {
     *   if (!err) {
     *     console.log(peerId);
     *   }
     * });
     */
    getPeerId: function (callback) {
      native.callNativeFunction('GetPeerID', callback);
    },

    /**
     * 获取sessionID
     * @function getSessionId
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.getSessionId(function (err, sessionId) {
     *   if (!err) {
     *     console.log(sessionId);
     *   }
     * });
     */
    getSessionId: function (callback) {
      native.callNativeFunction('GetSessionID', callback);
    },

    /**
     * 获取skinId
     * @function getSkinId
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.getSkinId(function (err, skinId) {
     *   if (!err) {
     *     console.log(skinId);
     *   }
     * });
     */
    getSkinId: function (callback) {
      native.callNativeFunction('GetSkinID', callback);
    },

    /**
     * 获取skinInfo
     * @function getSkinInfo
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.getSkinInfo(function (err, skinInfo) {
     *   if (!err) {
     *     console.log(skinInfo);
     *   }
     * });
     */
    getSkinInfo: function (skinId, callback) {
      native.callNativeFunction('GetSkinInfo', skinId, callback);
    },

    /**
     * 弹出登入框
     * @function showLoginDlg
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.showLoginDlg(function (err) {
     *   if (!err) {
     *     console.log('show login dialog');
     *   }
     * });
     */
    showLoginDlg: function (callback) {
      native.callNativeFunction('ShowLoginDlg', callback);
    },

    /**
     * 创建任务
     * @function createTask
     * @param {string} url - 下载链接
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.createTask('https://raw.githubusercontent.com/ElementUI/Resources/master/Element%20Components%20Documentation.zip', function (err) {
     *   if (!err) {
     *     console.log('task has been created');
     *   }
     * });
     */
    createTask: function (url, callback) {
      native.callNativeFunction('CreateTask', url, function (err) {
        if (err) {
          window.open(url);
        }
        callback(null);
      });
    },

    /**
     * 埋点统计
     * @function trackEvent
     * @param {dataCallback} callback - 回调函数
     * @param {object} opt - json
     * @param {string} opt.key - key
     * @param {string} opt.attr1 - attr1
     * @param {string} opt.attr2 - attr2
     * @param {string} opt.extData - extData
     * @example
     * xl9.api.trackEvent({
     *   key: "right_area",
     *   attr1: "home_page_show",
     *   extData: "version=c"
     * }, function (err) {
     *   if (!err) {
     *     console.log('track event');
     *   }
     * });
     */
    trackEvent: function (opt, callback) {
      var extendOpt = util.deepExtend({ // 合并默认字段
        key: '',
        attr1: '',
        attr2: '',
        cost1: 0,
        cost2: 0,
        cost3: 0,
        cost4: 0,
        extData: ''
      }, opt);

      native.callNativeFunction('TrackEvent',
        extendOpt.key,
        extendOpt.attr1,
        extendOpt.attr2,
        extendOpt.cost1,
        extendOpt.cost2,
        extendOpt.cost3,
        extendOpt.cost4,
        extendOpt.extData,
        callback);
    },


    /**
     * 打开新标签页
     * @function openNewTab
     * @param {object} opt - json
     * @param {string} opt.url - 新标签页链接
     * @param {boolean} opt.selected - 是否被选中
     * @param {string} opt.context - 标签页名称
     * @param {boolean} opt.mainTab - 是否是主页
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.openNewTab({
     *   url: 'lixian.xunlei.com/xl9/space.html?referfrom=v_pc_xl9_hytq_lx_lxkj',
     *   selected: false,
     *   context: 'offline_home',
     *   mainTab: false
     * }, function (err, tabId) {
     *   if (!err) {
     *     console.log(tabId);
     *   }
     * });
     */
    openNewTab: function (opt, callback) {
      var extendOpt = util.deepExtend({
        url: '',
        selected: true,
        context: null,
        mainTab: false
      }, opt);

      native.callNativeFunction('OpenNewTab', extendOpt.url, extendOpt.selected, extendOpt.context, extendOpt.mainTab, callback);
    },

    /**
     * 切换至客户端指定窗口
     * @function selectTab
     * @param {string} tabId - 标签页id
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.selectTab('4', function (err) {
     *   if (!err) {
     *     console.log('select tab');
     *   }
     * });
     */
    selectTab: function (tabId, callback) {
      native.callNativeFunction('SelectTab', tabId, callback);
    },

    /**
     * 判断客户端窗口是否存在
     * @function isTabExist
     * @param {string} tabId - 标签页id
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.isTabExist('4', function (err, exist) {
     *   if (!err) {
     *     console.log(exist);
     *   }
     * });
     */
    isTabExist: function (tabId, callback) {
      native.callNativeFunction('IsTabExist', tabId, callback);
    },

    /**
     * 根据context获得客户端窗口Id
     * @function getTabIdByContext
     * @param {string} context - 标签页名称
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.getTabIdByContext('offline_home', function (err, tabId) {
     *   if (!err) {
     *     console.log(tabId);
     *   }
     * });
     */
    getTabIdByContext: function (context, callback) {
      native.callNativeFunction('GetTabIDByContext', context, callback);
    },

    /**
     * 安装后是否第一次打开迅雷9
     * @function isMainPageFirstShow
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.isMainPageFirstShow(function (err, first) {
     *   if (!err) {
     *     console.log(first);
     *   }
     * });
     */
    isMainPageFirstShow: function (callback) {
      native.callNativeFunction('IsMainPageFirstShow', callback);
    },

    /**
     * 获得迅雷客户端版本号
     * @function getThunderVersion
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.getThunderVersion(function (err, version) {
     *   if (!err) {
     *     console.log(version);
     *   }
     * });
     */
    getThunderVersion: function (callback) {
      native.callNativeFunction('GetThunderVersion', callback);
    },

    /**
     * 写迅雷9配置文件
     * @function setConfigValue
     * @param {object} opt - json
     * @param {string} opt.section - section
     * @param {string} opt.key - key
     * @param {string} opt.value - value
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.setConfigValue({
     *   section: 'section',
     *   key: 'key',
     *   value: 'value'
     * }, function (err) {
     *   if (!err) {
     *     console.log('set config value');
     *   }
     * });
     */
    setConfigValue: function (opt, callback) {
      native.callNativeFunction('SetConfigValue', opt.section, opt.key, opt.value, callback);
    },

    /**
     * 读迅雷9配置文件
     * @function getConfigValue
     * @param {object} opt - json
     * @param {string} opt.section - section
     * @param {string} opt.key - key
     * @param {string} opt.defaultValue - 默认值
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.getConfigValue({
     *   section: 'section',
     *   key: 'key',
     *   defaultValue: 'value'
     * }, function (err, value) {
     *   if (!err) {
     *     console.log(value);
     *   }
     * });
     */
    getConfigValue: function (opt, callback) {
      native.callNativeFunction('GetConfigValue', opt.section, opt.key, opt.defaultValue, callback);
    },

    /**
     * 用户登出
     * @function logout
     * @param {dataCallback} callback - 回调函数
     * @example
     * xl9.api.logout(function (err) {
     *   if (!err) {
     *     console.log('logout');
     *   }
     * });
     */
    logout: function (callback) {
      native.callNativeFunction('Logout', callback);
    },

    /**
     * 用户登录事件
     * @function onUserLogin
     * @param {loginHandler} callback - 事件处理器
     * @returns {number} 事件标识
     * @example
     * xl9.api.onUserLogin(function (userId, jumpKey) {
     *   console.log('login emit');
     * });
     */
    onUserLogin: function (callback) {
      return event.loginAttach(callback);
    },

    /**
     * 用户登出事件
     * @function onUserLogout
     * @param {handler} callback - 事件处理器
     * @returns {number} 事件标识
     * @example
     * xl9.api.onUserLogout(function () {
     *   console.log('logout emit');
     * });
     */
    onUserLogout: function (callback) {
      return native.attachNativeEvent('OnUserLogout', callback);
    },

    /**
     * 用户换肤事件
     * @function onChangeSkin
     * @param {changeSkinHandler} callback - 事件处理器
     * @returns {number} 事件标识
     * @example
     * xl9.api.onChangeSkin(function (skinId, isVip, skinInfo) {
     *   console.log('change skin emit');
     * });
     */
    onChangeSkin: function (callback) {
      return native.attachNativeEvent('OnChangeSkin', callback);
    }
  },

  /**
   * 配置自动进行Jump key请求
   * @function autoJump
   * @param {boolean} auto - 是否自动进行Jump key请求
   * @example
   * xl9.autoJump(true);
   */
  autoJump: function (auto) {
    var that = this;

    conf.autoJump = auto;

    // 自动登录
    this.api.check('GetUserInfo', function (exist) {
      if (!exist && conf.autoJump) {
        that.api.getUserId(function (err, userId) { // 获取用户 ID
          if (!err && userId > 0) {
            that.api.getJumpKey(function (err, jumpKey) { // 获取 Jump Key
              if (!err) {
                util.jsonp({
                  url: conf.jumpUrl,
                  callback: 'callback',
                  data: {
                    u1: conf.jsonCallbackUrl + '?_=' + new Date().valueOf(),
                    jump_key: jumpKey
                  }
                });
              }
            });
          }
        });
      }
    });
  },

  /**
   * 是否在迅雷客户端
   * @function isThunder
   * @returns {boolean} 是否在迅雷客户端
   * @example
   * if (xl9.isThunder()) {
   *   console.log('is thunder');
   * }
   */
  isThunder: native.isThunder,

  /**
   * 通用登录
   * @function login
   * @param {dataCallback} callback - 回调函数
   * @example
   * xl9.login(function (err, userId) {
   *   if (!err) {
   *     console.log(userId);
   *   }
   * });
   */
  login: function (callback) {
    var that = this;

    if (!conf.autoJump) {
      return;
    }

    that.api.getUserId(function (err, userId) {
      if (err) { // 获取user id出错
        callback(err);
      } else {
        if (userId === '0') { // 未登录
          event.loginAttach(function (userId) {
            callback(null, userId);
          }, true);

          that.api.showLoginDlg(function (err) {
            if (err) {
              callback(err);
            }
          });
        } else { // 已登录
          callback(null, userId);
        }
      }
    });
  }
};

module.exports = xl9;




//////////////////
// WEBPACK FOOTER
// ./main.js
// module id = 1
// module chunks = 0